import IProcess from '@components/FormFlow/Interfaces/Process';
import { LocalStorageKeys } from '@containers/App';
import BasePaginationQuery from '@interfaces/base-pagination-query';
import { PillarNames } from '@interfaces/pillar';
import ProcessService from '@services/ehss/Process';
import ProcessLIService from '@services/ProcessLIService';
import ProcessServiceQA from '@services/qa/ProcessServiceQA';

export default class ProcessRequestsInterceptor {

  private processServiceEHSS: ProcessService = new ProcessService;
  private processServiceQA: ProcessServiceQA = new ProcessServiceQA;
  private processServiceLI: ProcessLIService = new ProcessLIService;
  private currentPillar: any;

  private idUnit: string = ''
  constructor() {

  }

  async paging<T extends IProcess>(query: BasePaginationQuery, fields?: string[]): Promise<T> {
    this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))

    let res;
    switch (this.currentPillar) {
      case PillarNames.EHSS:
        res = await this.processServiceEHSS.paging(query, fields);
        break;
      case PillarNames.QA:
        res = await this.processServiceQA.paging(query, fields);
        break;
      case PillarNames.LI:
        res = await this.processServiceLI.paging(query, fields);
        break;
    }
    return res;
  }

  async create<T extends IProcess>(data: T, unit: string): Promise<T> {
    this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);
    let res;

    switch (this.currentPillar) {
      case PillarNames.EHSS:
        res = await this.processServiceEHSS.create(data, unit);
        break;
      case PillarNames.QA:
        res = await this.processServiceQA.create(data, unit);
        break;
      case PillarNames.LI:
        res = await this.processServiceLI.create(data, unit);
        break;
    }

    return res;
  }

  async getById<T extends IProcess>(id: string, unit: string, data?: T): Promise<T> {
    this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);
    let res;

    switch (this.currentPillar) {
      case PillarNames.EHSS:
        res = await this.processServiceEHSS.getById(id, unit, data);
        break;
      case PillarNames.QA:
        res = await this.processServiceQA.getById(id, unit, data);
        break;
      case PillarNames.LI:
        res = await this.processServiceLI.getById(id, unit, data);
        break;
    }

    return res;
  }

  async updateById<T extends IProcess>(id: string, unit: string, data: T): Promise<T> {
    this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);
    let res;

    switch (this.currentPillar) {
      case PillarNames.EHSS:
        res = await this.processServiceEHSS.updateById(id, unit, data);
        break;
      case PillarNames.QA:
        res = await this.processServiceQA.updateById(id, unit, data);
        break;
      case PillarNames.LI:
        res = await this.processServiceLI.updateById(id, unit, data);
        break;
    }

    return res;
  }

  async unitAdd<T extends IProcess>(id: string, unitId: string, actualUnit: string): Promise<T> {
    this.currentPillar = localStorage.getItem('pillar');
    let res;

    switch (this.currentPillar) {
      case PillarNames.EHSS:
        res = await this.processServiceEHSS.unitAdd(id, unitId, actualUnit);
        break;
      case PillarNames.QA:
        res = await this.processServiceQA.unitAdd(id, unitId, actualUnit);
        break;
      case PillarNames.LI:
        res = await this.processServiceLI.unitAdd(id, unitId, actualUnit);
        break;
    }

    return res;
  }

  async unitRemove(id: string, unitId: string, actualUnit: string): Promise<IProcess> {
    this.currentPillar = localStorage.getItem('pillar');
    let res;

    switch (this.currentPillar) {
      case PillarNames.EHSS:
        res = await this.processServiceEHSS.unitRemove(id, unitId, actualUnit);
        break;
      case PillarNames.QA:
        res = await this.processServiceQA.unitRemove(id, unitId, actualUnit);
        break;
      case PillarNames.LI:
        res = await this.processServiceLI.unitRemove(id, unitId, actualUnit);
        break;
    }

    return res;
  }

  async deleteById(id: string, unit: string): Promise<void> {
    this.currentPillar = localStorage.getItem('pillar');
    this.idUnit = String(localStorage.getItem(LocalStorageKeys.ACTIVE_UNIT_ID))

    switch (this.currentPillar) {
      case PillarNames.EHSS:
        await this.processServiceEHSS.deleteById(id, unit);
        break;
      case PillarNames.QA:
        await this.processServiceQA.deleteById(id, unit);
        break;
      case PillarNames.LI:
        await this.processServiceLI.deleteById(id, unit);
        break;
    }
  }

  async langAdd(id: string, langId: string, unit: string, data: { [key: string]: string }): Promise<any> {
    this.currentPillar = localStorage.getItem('pillar');
    let res;

    switch (this.currentPillar) {
      case PillarNames.EHSS:
        res = await this.processServiceEHSS.langAdd(id, langId, unit, data);
        break;
      case PillarNames.LI:
        res = await this.processServiceLI.langAdd(id, langId, unit, data);
        break;
    }

    return res;
  }

}